import {environment} from "@env-team/environment";
import {SharedKnowledgeState} from "./knowledge.state";
import {createReducer, on} from "@ngrx/store";
import {SharedKnowledgeActions} from "./knowledge.actions-type";
import {cloneDeep} from 'lodash';

export const initialKnowledgeState: SharedKnowledgeState = {
  page: {},
  items: [],
  activeSummary: null,
  activePath: {},
  activeArticle: {},
  activeExam: null,
  paging: {
    totalItems: 0,
    pageNumber: 0,
    pageSize: environment?.apiUrl?.pageDefaultSize || 50,
    totalPages: 1
  },
  isLoading: true
};

export const sharedKnowledgeStore = createReducer(
  initialKnowledgeState,
  on(SharedKnowledgeActions.getPathItemsPaged, (state) => ({
    ...state,
    isLoading: true
  })),
  on(SharedKnowledgeActions.getPathItemsPagedCancel, (state) => ({
    ...state,
    isLoading: false
  })),
  on(SharedKnowledgeActions.getPathItemsPagedSuccess, (state, { data }) => ({
    ...state,
    // Important! include the current state.items and the data.items to create a new array with the
    // existing ones and the new one that is requested
    items: [...state.items, ...data.items],
    paging: data.paging,
    isLoading: false
  })),
  on(SharedKnowledgeActions.getPathItemsPagedFail, (state) => ({
    ...state,
    isLoading: false
  })),
  on(SharedKnowledgeActions.getPathItemsPagedRefresh, (state, { data }) => ({
    ...state,
    items: [...data.items],
    paging: data.paging,
    isLoading: false
  })),
  on(SharedKnowledgeActions.getKnowledgePathById, (state) => ({
    ...state,
    isLoading: true
  })),
  on(SharedKnowledgeActions.getPathItemsByIdStartSuccess, (state, { data }) => ({
    ...state,
    activePath: data,
    isLoading: false
  })),
  on(SharedKnowledgeActions.getPathItemsByIdStartFail, (state) => ({
    ...state,
    isLoading: false
  })),
  on(SharedKnowledgeActions.getPathItemsByIdStartRefresh, (state, { data }) => ({
    ...state,
    activePath: data,
    isLoading: false
  })),
  on(SharedKnowledgeActions.getItemsSearched, (state) => ({
    ...state,

    paging: {
      totalItems: initialKnowledgeState.paging.totalItems,
      pageNumber: initialKnowledgeState.paging.pageNumber,
      pageSize: initialKnowledgeState.paging.pageSize,
      totalPages: initialKnowledgeState.paging.totalPages,
    },
    isLoading: true
  })),
  on(SharedKnowledgeActions.getItemsSearchedSuccess, (state, { data, summary }) =>
    ({
      ...state,
      items: [...data.items],
      paging: data.paging,
      activeSummary: summary,
      isLoading: false
    })
  ),
  on(SharedKnowledgeActions.getItemsSearchedFail, (state) => ({
    ...state,
    activeSummary: null,
    isLoading: false
  })),
  on(SharedKnowledgeActions.getArticlePage, (state) => ({
    ...state,
    isLoading: true
  })),
  on(SharedKnowledgeActions.getArticlePageSuccess, (state, { data }) => ({
    ...state,
    activeArticle: data,
    isLoading: false
  })),
  on(SharedKnowledgeActions.getArticlePageFail, (state) => ({
    ...state,
    isLoading: false
  })),
  on(SharedKnowledgeActions.getExamAnswerById, (state) => ({
    ...state,
    isLoading: true
  })),
  on(SharedKnowledgeActions.getExamAnswerByIdSuccess, (state, { data }) => ({
    ...state,
    activeExam: data,
    isLoading: false
  })),
  on(SharedKnowledgeActions.getExamAnswerByIdFail, (state) => ({
    ...state,
    isLoading: false
  })),

  on(SharedKnowledgeActions.clearActiveExam, (state) => ({
    ...state,
    activeExam: null
  })),

  on(SharedKnowledgeActions.updateActiveExam, (state, { data }) => ({
    ...state,
    activeExam: cloneDeep(data),
  })),

  on(SharedKnowledgeActions.submitExamAnswer, (state) => ({
    ...state,
    isLoading: true
  })),

  on(SharedKnowledgeActions.submitExamAnswerSuccess, (state, { data }) => ({
    ...state,
    activeExam: data,
    isLoading: false
  })),

  on(SharedKnowledgeActions.submitExamAnswerFail, (state) => ({
    ...state,
    isLoading: false
  })),
)
